interface Employee {
  mothersNamePrefix?: string;
  mothersLastName?: string;
  mothersFirstName?: string;
  mothersFirstName2?: string;
  mothersNameSuffix?: string;
}

export const getMothersFullName = (employee: Employee) => {
  if (!employee) return null;
  let mothersPrefixName = employee.mothersNamePrefix
    ? employee.mothersNamePrefix + " "
    : "";
  let mothersLastName = employee.mothersLastName
    ? employee.mothersLastName + " "
    : "";
  let mothersFirstName = employee.mothersFirstName
    ? employee.mothersFirstName + " "
    : "";
  let mothersFirstName2 = employee.mothersFirstName2
    ? employee.mothersFirstName2 + " "
    : "";
  let mothersNameSuffix = employee.mothersNameSuffix
    ? employee.mothersNameSuffix + " "
    : "";

  let mothersfullname =
    mothersPrefixName +
    mothersLastName +
    mothersFirstName +
    mothersFirstName2 +
    mothersNameSuffix;

  return mothersfullname?.trim();
};

export default getMothersFullName;
